import { initializeApp, getApps, getApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBw1T8nbpf5sEr-YGos3OF352grKIQynBg",
  authDomain: "o-live-music.firebaseapp.com",
  projectId: "o-live-music",
  storageBucket: "o-live-music.firebasestorage.app",
  messagingSenderId: "474196453000",
  appId: "1:474196453000:web:4c129c5509aa0dfc8ca13d"
}

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp()

// Initialize Firebase services
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)

export default app
